import styled from 'styled-components';

export const MobileItem = styled.li`
  @media (min-width: 992px) {
    display: none;
  }
`;
